import { actionDeclarer } from '../services/actionDeclarer';

import { mapPermissions } from '../services/utils';

export const {
	SIGN_IN,
	SIGN_OUT
} = actionDeclarer;

const authReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SIGN_IN: {
			const {
				permissions,
				...portal
			} = payload.portal;

			const mappedPermissions = mapPermissions( permissions );

			return {
				...state,
				user: {
					...payload,
					portal,
					permissions: mappedPermissions
				}
			};
		}

		case SIGN_OUT:
			return {
				...state,
				user: null
			};
		default:
			return state;
	}
};

export default authReducer;
